import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { alertsRoutes } from "./routes";

export const alertsRoute = [
  {
    path: alertsRoutes.list,
    lazy: async () => {
      const { ListAlertsPage } = await import("./pages/list/ListAlertsPage");

      return { element: <ListAlertsPage /> };
    },
  },
  {
    path: alertsRoutes.settings,
    lazy: async () => {
      const { SettingsAlertsPage } = await import("./pages/settings/SettingsAlertsPage");

      return { element: <SettingsAlertsPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
